import TutorSearchResultsRow from './TutorSearchResultsRow'
import TutorSearchBanner from './tutorSearch/Banner'

export default function TutorSearchResultsList({results, subject, level}) {
  return (
    <div>
      {results.map((tutorProfile, index) => (
        <>
          <div className="mb-3" key={tutorProfile.id}>
            <TutorSearchResultsRow tutorProfile={tutorProfile} subject={subject} level={level} />
          </div>

           {(index === 2 || index === results.length - 1) &&
             <div className="mb-3">
               <TutorSearchBanner />
             </div>
           }
        </>
      ))}
    </div>
  )
}
